import React, { useState, useEffect } from "react";
import { GoogleApiWrapper } from "google-maps-react";
import { TextField } from "@material-ui/core";

// import './map.css'

const MapContainer = (props) => {
  const { updateMapInfo, className, placeholder, ...rest } = props;
  const [MapState, setMapState] = useState({
    location: "",
    streetNumber: "",
    street: "",
    city: "",
    state: "",
    stateCode: "",
    zipCode: "",
    country: "",
  });

  useEffect(() => {
    updateMapInfo(MapState); // pass data to the parent component
  }, [MapState]);

  const handleChange = (e) => {
    e.preventDefault();
    setMapState({ ...MapState, location: MapState.location });

    var Gmap_Address = "";

    function initAutocomplete() {
      var input = document.getElementById(props.id);

      var autoComplete = new window.google.maps.places.Autocomplete(input, {
        types: ["geocode"],
      });

      autoComplete.setFields(["address_components", "formatted_address"]);

      autoComplete.addListener("place_changed", () => {
        var place = autoComplete.getPlace();

        for (var i = 0; i < place?.address_components?.length; i++) {
          var addressType = place.address_components[i].types[0];
          switch (addressType) {
            case "street_number":
              var streetNumber = place.address_components[i]["short_name"];
              Gmap_Address += streetNumber + " ";
              break;
            case "route":
              var street = place.address_components[i]["long_name"];
              Gmap_Address += street + ", ";
              break;
            case "locality":
              var city = place.address_components[i]["long_name"];
              Gmap_Address += city + ", ";
              break;
            case "administrative_area_level_1":
              var stateCode = place.address_components[i]["short_name"];
              var state = place.address_components[i]["long_name"];
              Gmap_Address += stateCode + ", ";
              break;
            case "postal_code":
              var zipCode = place.address_components[i]["short_name"];
              Gmap_Address += zipCode;
              break;
            case "country":
              var country = place.address_components[i]["long_name"];
              break;
            default:
              break;
          }
        }

        setMapState({
          location: Gmap_Address,
          streetNumber: streetNumber,
          street: street,
          city: city,
          state: state,
          stateCode: stateCode,
          zipCode: zipCode,
          country: country,
        });
      });
    }

    initAutocomplete();
  };

  return (
    <div className="text-field">
      <TextField
        {...rest}
        size="small"
        fullWidth
        color="secondary"
        onFocus={handleChange}
        className={className}
        type="text"
        placeholder={placeholder}
      />
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAP_API_TOKEN,
})(MapContainer);
